import { api, resolvePagination } from './api';
import { getLastYearDate, getRequestDate } from 'utils/dateUtils';

/**
 * Get a list of medical (stress) tests
 */
export const getStressTests = async ({
    patient,
    group,
    type,
    pageLimit,
    pageToken,
    qi = getLastYearDate(1),
    qf = null
}) =>
    api.post(
        '/cheart/md-tests',
        {
            patient,
            group,
            type,
            qi: qi ? getRequestDate(qi) : undefined,
            qf: qf ? getRequestDate(qf) : undefined
        },
        {
            headers: resolvePagination(pageToken, pageLimit)
        }
    );

/**
 * Fetch a single medical (stress) test by UUID
 */
export const fetchStressTest = async (uuid) => {
    return await api.post('/cheart/md-tests/fetch', { uuid });
};

/**
 * Create a new medical (stress) test
 */
export const createStressTest = async ({ patient, doctor, caregiver, type, ts, data }) =>
    api.post('/cheart/md-tests/add', {
        patient,
        doctor,
        caregiver,
        type,
        ts,
        data
    });

/**
 * Upload a file to a medical (stress) test
 */
export const uploadStressTestFile = async ({ testUuid, file }) => {
    const formData = new FormData();
    formData.append('test', testUuid);
    formData.append('file', file);

    return api.post('/cheart/md-tests/upload', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
};
